<template>
  <div>
    <!-- <OneAssignment/> -->

    <el-dialog title="提示" :visible.sync="tagImgDialog" width="60%">
      <div class="t-u-w">
        <TagImgUpload ref="tu" @uploadSuccess="uploadSuccess" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleImgUploadClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSureUpload"
          :loading="subTagLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <div class="breadcrumb-wrap">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        class="breadcrumb-custom"
      >
        <el-breadcrumb-item>二级标签管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="a-t">
      <el-button @click="handleAddTag" type="primary">
        新增
      </el-button>
    </div>
    <LoadingNoDialog :loading="loading">
      <el-table
        class="clear-fix"
        border
        :empty-text="emptyText"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column label="名称" prop="name"> </el-table-column>

        <el-table-column prop="payCode" label="图片">
          <template slot-scope="scope">
            <img :src="scope.row.img" style="height: 140px" />
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button
              type="info"
              size="small"
              @click="(e) => editTag(scope.row)"
              >编辑</el-button
            >
            <el-button type="danger" size="small" @click="e=>deleteClick(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间"> </el-table-column>
      </el-table>

      <div style="margin-top: 10px; text-align: right">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100, 500, 1000]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </LoadingNoDialog>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import LoadingNoDialog from "../../components/LoadingNoDialog.vue";
import ElButton from "../../../node_modules/element-ui/packages/button/src/button.vue";
import TagImgUpload from "./component/TagImgUpload.vue";
import OneAssignment from './component/OneAssignment.vue'

export default {
  name: "Role",
  data() {
    return {
      emptyText: "暂无数据",
      size: 10,
      page: 1,
      tableData: [],
      total: 0,
      loading: false,
      tagImgDialog: false,
      tagInfo: {
        objectKey: "",
        imgUrl: "",
      },
      subTagLoading: false,
      isAdd: true,
    };
  },
  components: {
    ElButton,
    LoadingNoDialog,
    TagImgUpload,

    OneAssignment
  },
  mounted() {
    this.getList();
  },
  methods: {
    editTag(row) {
      this.tagInfo = {
        imgUrl: row.img,
        objectKey: row.objectKey,
      };
      this.tagImgDialog = true;
      this.$nextTick(() => {
        this.$refs.tu.setValue({ name: row.name, ...row, imgUrl: row.img });
        this.isAdd = false;
      });
    },
    handleImgUploadClose() {
      this.tagImgDialog = false;
    },
    handleSureUpload() {
      if (this.isAdd) {
        this.submitAddTag();
      } else {
        this.submitEditTag();
      }
    },

    handleAddTag() {
      this.isAdd = true;
      this.tagImgDialog = true;
      this.$nextTick(() => {
        this.$refs.tu.setValue({ name: "", imgUrl: null });
      });
    },
    async submitEditTag() {
      let name = this.$refs.tu.name;
      let id = this.$refs.tu.id;

      this.subTagLoading = true;
      let r = await axios.post("/admin/edit-two-tag", {
        id,
        name,
        img: this.tagInfo.objectKey,
      });
      this.subTagLoading = false;
      this.handleImgUploadClose();
      if (r.code == 0) {
        this.$message({
          message: "修改成功",
          type: "success",
        });
        this.getList();
      } else {
        this.$message("修改失败");
      }
    },
    async submitAddTag() {
      let name = this.$refs.tu.name;
      this.subTagLoading = true;
      let r = await axios.post("/admin/add-two-tag", {
        name,
        img: this.tagInfo.objectKey,
        type:2
      });
      this.subTagLoading = false;
      this.handleImgUploadClose();
      if (r.code == 0) {
        this.$message({
          message: "新增成功",
          type: "success",
        });
        this.getList();
      } else {
        this.$message("新增失败");
      }
    },
    deleteClick(row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let r=await axios.delete('/admin/delete-two-tag',{
          params:{id:row.id}
        })
        if(r.code==0){
            this.$message({
          message: "删除成功",
          type: "success",
        });
        }
        this.getList()
        
      });
    },

    uploadSuccess(obj) {
      this.tagInfo.objectKey = obj.objectKey;
      this.tagInfo.imgUrl = obj.url;
    },
    async handleClick(row) {},
    handleExceed() {},
    async getList() {
      this.loading = true;
      let r = await axios.get("/admin/two-tag-lists", {
        params: { page: this.page, size: this.size, type:2 },
      });
      if (r.code == 51) {
        this.loading = false;
        this.emptyText = "无权限";
        return;
      }
      this.tableData = r.data.rows.map((item) =>
        Object.assign(item, {
          createdAt: moment(item.createdAt).format("YYYY/MM/DD HH:mm:ss"),
        })
      );

      this.total = r.data.count;
      this.loading = false;
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
  },
};
</script>
<style scoped>
.t-u-w {
  display: flex;
  justify-content: center;
}
.a-t {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/main/admin/TwoTag.vue